/**
 * Sentry initialization for SystemDox.
 * Thin wrapper around shared-observability's initObservability().
 */

import {
  initObservability,
  captureError as _captureError,
  captureMessage as _captureMessage,
  addBreadcrumb as _addBreadcrumb,
  setUser as _setUser,
} from '@puglieseweb/shared-observability';

export function initSentryEssential() {
  initObservability({
    product: 'systemdox',
    errorCodePrefix: 'SYD',
    dsn: import.meta.env.REACT_APP_SENTRY_DSN || '',
    environment: import.meta.env.REACT_APP_ENVIRONMENT || 'development',
    release: import.meta.env.REACT_APP_VERSION || 'systemdox-react@0.1.0',
    debugStorageKey: 'systemdox_debug',
    debug: import.meta.env.REACT_APP_SENTRY_DEBUG === 'true',
  });
}

export const captureError = _captureError;
export const captureMessage = _captureMessage;
export const addBreadcrumb = _addBreadcrumb;
export const setUser = _setUser;
